<template>
	<div class="fogo-nightly-banner relative w-full max-sm:mt-[50px]">
		<div
			class="flex items-center justify-between gap-1 px-2 py-1 max-w-full mx-auto max-[480px]:px-3 max-[480px]:py-1.5 max-[480px]:gap-1.5"
		>
			<div class="flex items-center gap-3 flex-1 min-w-0">
				<img
					src="/images/socials/nightly_logo.png"
					alt="Nightly Wallet"
					class="h-7 w-auto object-contain nightly-logo hidden sm:block max-sm:h-6"
				/>
				<span
					class="banner-text text-white font-semibold text-[0.9375rem] leading-normal flex-1 min-w-0 max-sm:text-[0.813rem] max-[480px]:text-xs"
				>
					To access FOGO, we recommend using
					<a
						href="https://nightly.app/"
						target="_blank"
						rel="noopener noreferrer"
						class="banner-link text-white font-bold underline max-sm:text-[0.813rem]"
					>
						Nightly Wallet
					</a>
				</span>
			</div>
			<button
				v-if="canDismiss"
				@click="dismissBanner"
				class="dismiss-button btn btn-sm"
				aria-label="Dismiss banner"
			>
				<span class="!text-sm max-sm:!text-xs">Dismiss</span>
			</button>
		</div>
	</div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';

// Props
const props = defineProps<{
	canDismiss?: boolean;
}>();

// Emits
const emit = defineEmits(['dismiss']);

// Methods
function dismissBanner() {
	if (!props.canDismiss) return;
	localStorage.setItem('fogo-nightly-banner-dismissed', 'true');
	emit('dismiss');
}
</script>

<style scoped>
.fogo-nightly-banner {
	/* background: linear-gradient(135deg, #ff3d00 0%, #ff5722 100%); */
	/* border-bottom: 2px solid rgba(255, 87, 34, 0.8); */
	/* Get red color from Fluxbot not connected on Navbar */
	background: #dc3545;
	border: #dc3545;
	box-shadow: 0 2px 8px rgba(255, 61, 0, 0.3);
	z-index: 10;
}

@media (min-width: 640px) {
	.fogo-nightly-banner {
		margin-left: 55px;
		width: calc(100% - 55px);
	}
}

.nightly-logo {
	filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.banner-text {
	text-align: left;
	text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.banner-link {
	text-decoration-color: rgba(255, 255, 255, 0.5);
	text-decoration-thickness: 2px;
	text-underline-offset: 2px;
	transition: all 0.2s ease;
}

.banner-link:hover {
	text-decoration-color: rgba(255, 255, 255, 1);
	text-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
}

.dismiss-button {
	background: rgba(0, 0, 0, 0.15) !important;
	border: 1px solid rgba(255, 255, 255, 0.3) !important;
	transition: all 0.2s ease;
}

.dismiss-button:hover {
	background: rgba(0, 0, 0, 0.25) !important;
	border-color: rgba(255, 255, 255, 0.5) !important;
	transform: translateY(-1px);
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
}
</style>
